module.exports = __webpack_public_path__ + "img/cover.a984268f.jpg";